import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Grid2,
    IconButton,
    TextField,
    useTheme,
} from "@mui/material";
import * as React from "react";
import { IoMdClose } from "react-icons/io";
import { useUpdateImageGalleryStatusMutation } from "store/slices/apis/imageGallerySlice";
import { useUpdateManpowerStatusMutation } from "store/slices/apis/manpowerSlice";

export default function ApproveImageGallery(props) {
    const {
        closeAndOpen,
        cancel,
        rowData,
        openNotification,
        clearData
    } = props;
    const theme = useTheme();
    const [comment, setComment] = React.useState("");

    const [updateImageGallery, updatImageGalleryRes] = useUpdateImageGalleryStatusMutation();
    const handleApprove = () => {
        const formdata = new FormData();
        formdata.append("status", "Approved");
        formdata.append("Comment", "");
        if (rowData != null) {
            rowData?.map((value, key) => {
                formdata.append('ids', value)
            })
        }

        updateImageGallery(formdata);
    };

    React.useEffect(() => {
        if (updatImageGalleryRes?.isSuccess) {
            if (updatImageGalleryRes?.data?.status == "success") {
                openNotification(updatImageGalleryRes?.data?.message, "success");
                setComment("");
                cancel();
                clearData();
            } else {
                openNotification(updatImageGalleryRes?.data?.message, "error");
            }
        }
    }, [updatImageGalleryRes?.isSuccess]);
    return (
        <React.Fragment>
            <Dialog
                open={closeAndOpen}
                onClose={cancel}
                disableEnforceFocus
                disableRestoreFocus
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={"sm"}
            >
                <DialogTitle
                    sx={{
                        fontWeight: 500,
                        fontSize: "20px",
                        color: "#252525",
                        paddingBottom: 0,
                    }}
                    id="draggable-dialog-title"
                >
                    Approve
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={cancel}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    }}
                >
                    <IoMdClose style={{ fontSize: "20px" }} />
                </IconButton>
                <DialogContent>
                    <DialogContentText
                        sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
                    >
                        Are you sure you want to approve these images ? This
                        action is permanent.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={handleApprove}
                        loading={updatImageGalleryRes?.isLoading}
                        sx={{
                            backgroundColor: `${theme?.customSettings?.themeColor}`,
                            color: "#fff",
                            fontSize: "16px",
                            fontWeight: "500",
                            textTransform: "none",
                        }}
                    >
                        Approve
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
